export default __webpack_public_path__ + "static/media/ic-search.64dc5f2e.svg";